// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   CREATE USER — Professional Onboarding
   Three-step flow with Stripe-style step rail.
   Influences: Stripe (locked-step gating), Airtable (record
   cards), IBM Carbon (calm density, functional restraint).
   ============================================================ */

:host {
	--bg:              #FFFFFF;
	--bg-subtle:       #F7F7F5;
	--bg-locked:       #FAFAF9;
	--ink:             #161616;
	--ink-soft:        #393939;
	--ink-muted:       #525252;
	--ink-quiet:       #8D8D8D;
	--ink-faint:       #BDBDBD;
	--rule:            #E0E0E0;
	--rule-soft:       #EDEDED;
	--accent:          #2D6C35;
	--accent-deep:     #1F4E25;
	--accent-soft:     #EEF3EE;
	--warn:            #8A5A1F;
	--warn-soft:       #FBF3E4;
	--err:             #DA1E28;
	--ok:              #2D6C35;

	--sans:            'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
	--mono:            'IBM Plex Mono', 'SF Mono', Menlo, Consolas, monospace;
}

/* ---------------- PAGE ---------------- */

.cu-page {
	min-height: 100vh;
	background: var(--bg);
	padding: 56px 24px 96px;
	font-family: var(--sans);
	color: var(--ink);
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.cu-paper {
	max-width: 820px;
	margin: 0 auto;
	display: block;
}

/* ---------------- MASTHEAD ---------------- */

.cu-masthead {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 20px;
	border-bottom: 1px solid var(--rule);
	margin-bottom: 56px;
}

.cu-brand { display: flex; align-items: center; gap: 12px; }

.cu-brand-mark {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	background: var(--ink);
	color: var(--bg);
	font-family: var(--mono);
	font-weight: 500;
	font-size: 11px;
	letter-spacing: 0.06em;
	border-radius: 2px;
}

.cu-brand-name {
	font-family: var(--sans);
	font-weight: 500;
	font-size: 13px;
	letter-spacing: 0.01em;
	color: var(--ink);
}

.cu-masthead-meta {
	font-family: var(--mono);
	font-size: 11px;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--ink-quiet);
}

/* ---------------- TITLE BLOCK ---------------- */

.cu-title-block {
	margin: 0 0 40px;
	padding-left: 80px;
}

.cu-kicker {
	font-family: var(--mono);
	font-size: 11px;
	letter-spacing: 0.14em;
	text-transform: uppercase;
	color: var(--ink-muted);
	margin: 0 0 16px;
}

.cu-headline {
	font-family: var(--sans);
	font-weight: 500;
	font-size: clamp(28px, 4vw, 36px);
	line-height: 1.2;
	letter-spacing: -0.018em;
	color: var(--ink);
	margin: 0 0 14px;
}

.cu-deck {
	font-family: var(--sans);
	font-weight: 400;
	font-size: 15px;
	line-height: 1.6;
	color: var(--ink-muted);
	max-width: 38em;
	margin: 0;
}

/* ---------------- STEP RAIL (Stripe-style) ---------------- */

.cu-rail {
	display: flex;
	align-items: center;
	margin: 0 0 48px;
	padding: 0 0 0 80px;
	gap: 0;
}

.cu-rail-step {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
	min-width: 120px;
}

.cu-rail-node {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: 1.5px solid var(--rule);
	background: var(--bg);
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: var(--mono);
	font-weight: 500;
	font-size: 12px;
	color: var(--ink-quiet);
	transition: all 200ms ease;
	line-height: 1;
}

.cu-rail-step.is-active .cu-rail-node {
	border-color: var(--ink);
	color: var(--ink);
	background: var(--bg);
	box-shadow: 0 0 0 4px rgba(22, 22, 22, 0.06);
}

.cu-rail-step.is-done .cu-rail-node {
	border-color: var(--accent);
	background: var(--accent);
	color: var(--bg);
}

.cu-rail-step.is-locked .cu-rail-node {
	background: var(--bg-locked);
	border-color: var(--rule-soft);
	color: var(--ink-faint);
}

.cu-rail-label {
	font-family: var(--mono);
	font-size: 10px;
	font-weight: 500;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--ink-quiet);
	text-align: center;
	white-space: nowrap;
	line-height: 1.3;
	transition: color 200ms ease;
}

.cu-rail-optional {
	display: block;
	font-size: 9px;
	letter-spacing: 0.06em;
	color: var(--ink-faint);
	margin-top: 2px;
}

.cu-rail-step.is-active .cu-rail-label { color: var(--ink); }
.cu-rail-step.is-done .cu-rail-label   { color: var(--ink-soft); }
.cu-rail-step.is-locked .cu-rail-label { color: var(--ink-faint); }

.cu-rail-link {
	flex: 1;
	height: 1px;
	background: var(--rule);
	margin: 0 -8px;
	min-width: 24px;
	max-width: 80px;
	transition: background 240ms ease;
	margin-bottom: 24px; /* vertical-align with node centers */
}

.cu-rail-link.is-done { background: var(--accent); }

/* ---------------- SECTION FRAME ---------------- */

.cu-section {
	display: grid;
	grid-template-columns: 80px 1fr;
	gap: 0;
	padding: 44px 0 8px;
	border-top: 1px solid var(--rule-soft);
	transition: opacity 240ms ease;
}

.cu-section:first-of-type { border-top: 1px solid var(--rule); }

.cu-section.is-locked {
	opacity: 0.5;
	pointer-events: none;
}

.cu-section--usef {
	padding-top: 48px;
	margin-top: 12px;
	border-top: 1px solid var(--rule);
}

.cu-section-rail {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-top: 2px;
}

.cu-section-num {
	font-family: var(--mono);
	font-weight: 500;
	font-size: 12px;
	letter-spacing: 0.05em;
	color: var(--ink-quiet);
	line-height: 1;
	transition: color 200ms ease;
}

.cu-section.is-complete .cu-section-num { color: var(--accent); }
.cu-section.is-active .cu-section-num { color: var(--ink); }

.cu-section-rule {
	display: block;
	width: 24px;
	height: 1px;
	background: var(--rule);
	margin-top: 12px;
	transition: background 200ms ease, width 200ms ease;
}

.cu-section.is-complete .cu-section-rule { background: var(--accent); width: 36px; }
.cu-section.is-active .cu-section-rule   { background: var(--ink); width: 36px; }

.cu-section-body { min-width: 0; }

.cu-section-head {
	display: flex;
	align-items: baseline;
	gap: 12px;
	margin-bottom: 10px;
}

.cu-section-title {
	font-family: var(--sans);
	font-weight: 500;
	font-size: 19px;
	line-height: 1.25;
	letter-spacing: -0.005em;
	color: var(--ink);
	margin: 0;
	flex: 1;
}

.cu-section-status {
	font-family: var(--mono);
	font-size: 10px;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	padding: 3px 8px;
	border-radius: 2px;
	white-space: nowrap;
}

.cu-section-status--optional,
.cu-section-status--required,
.cu-section-status--locked {
	color: var(--ink-muted);
	border: 1px solid var(--rule);
	background: transparent;
}

.cu-section-status--locked {
	color: var(--ink-faint);
	border-color: var(--rule-soft);
}

.cu-section-status--done,
.cu-section-status--unlocked {
	color: var(--bg);
	background: var(--accent);
	border: 1px solid var(--accent);
}

.cu-prose {
	font-family: var(--sans);
	font-weight: 400;
	font-size: 14px;
	line-height: 1.6;
	color: var(--ink-muted);
	margin: 0 0 20px;
	max-width: 40em;
}

/* ---------------- SUB-GROUP LABEL ---------------- */
/* Used inside a section to mark a logical group (Name / Phone / Email) */

.cu-subgroup-label {
	display: flex;
	align-items: center;
	gap: 10px;
	font-family: var(--mono);
	font-size: 10px;
	font-weight: 500;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--ink-quiet);
	margin: 24px 0 12px;
	padding-bottom: 6px;
	border-bottom: 1px solid var(--rule-soft);
}

.cu-subgroup-label:first-of-type { margin-top: 4px; }

.cu-subgroup-flag {
	font-size: 9px;
	letter-spacing: 0.08em;
	color: var(--warn);
	padding: 2px 6px;
	background: var(--warn-soft);
	border-radius: 2px;
}

.cu-subgroup-flag--quiet {
	color: var(--ink-quiet);
	background: var(--surface-quiet, rgba(0, 0, 0, 0.04));
}

/* ---------------- BUTTONS ---------------- */

.cu-btn {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-family: var(--sans);
	font-weight: 500;
	font-size: 14px;
	padding: 11px 18px;
	border-radius: 2px;
	border: 1px solid transparent;
	background: transparent;
	cursor: pointer;
	transition: background 140ms ease, color 140ms ease, border-color 140ms ease;
	line-height: 1;
}

.cu-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.cu-btn--ghost {
	color: var(--ink);
	border-color: var(--ink);
}

.cu-btn--ghost:hover:not(:disabled) {
	color: var(--bg);
	background: var(--ink);
}

.cu-btn--primary {
	color: var(--bg);
	background: var(--accent);
	border-color: var(--accent);
}

.cu-btn--primary:hover:not(:disabled) {
	background: var(--accent-deep);
	border-color: var(--accent-deep);
}

.cu-btn--commit {
	color: var(--bg);
	background: var(--ink);
	border-color: var(--ink);
	padding: 13px 24px;
	font-size: 14px;
}

.cu-btn--commit:hover:not(:disabled) {
	background: var(--accent-deep);
	border-color: var(--accent-deep);
}

.cu-action-row {
	display: flex;
	align-items: center;
	gap: 18px;
	margin-top: 4px;
}

.cu-link {
	font-family: var(--sans);
	font-weight: 500;
	font-size: 13px;
	color: var(--accent);
	background: transparent;
	border: none;
	padding: 6px 0;
	cursor: pointer;
	text-decoration: none;
	border-bottom: 1px solid transparent;
	transition: border-color 140ms ease;
}

.cu-link:hover { border-bottom-color: var(--accent); }
.cu-link--muted { color: var(--ink-muted); }
.cu-link--muted:hover { color: var(--ink); border-bottom-color: var(--ink); }

/* ---------------- CHANNEL TOGGLE (Phone type) ---------------- */

.cu-channel-toggle {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0;
	margin: 0 0 18px;
	border: 1px solid var(--rule);
	border-radius: 2px;
	overflow: hidden;
	background: var(--bg);
	max-width: 480px;
}

.cu-channel {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 12px 16px;
	background: transparent;
	border: none;
	border-right: 1px solid var(--rule);
	cursor: pointer;
	text-align: left;
	transition: background 140ms ease;
	font-family: inherit;
}

.cu-channel:last-child { border-right: none; }
.cu-channel:hover:not(.is-active) { background: var(--bg-subtle); }

.cu-channel.is-active {
	background: var(--ink);
	color: var(--bg);
}

.cu-channel-label {
	font-family: var(--mono);
	font-size: 10px;
	font-weight: 500;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--ink-quiet);
	margin-bottom: 4px;
}

.cu-channel.is-active .cu-channel-label { color: var(--bg); opacity: 0.65; }

.cu-channel-value {
	font-family: var(--sans);
	font-size: 14px;
	font-weight: 500;
	color: var(--ink);
	letter-spacing: -0.003em;
}

.cu-channel.is-active .cu-channel-value { color: var(--bg); }

/* ---------------- PHONE / EMAIL ROW ---------------- */
/* A row that pairs an input field on the left with a verify-action slot on the right. */

.cu-phone-row {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(280px, 1fr);
	gap: 24px;
	align-items: start;
	margin-bottom: 4px;
}

.cu-phone-cluster {
	display: flex;
	align-items: stretch;
	border: 1px solid var(--rule);
	border-radius: 2px;
	overflow: hidden;
	background: var(--bg);
	transition: border-color 140ms ease;
}

.cu-phone-cluster:focus-within { border-color: var(--ink); }

.cu-phone-prefix {
	display: inline-flex;
	align-items: center;
	padding: 0 12px;
	background: var(--bg-subtle);
	color: var(--ink-muted);
	font-family: var(--mono);
	font-size: 14px;
	font-weight: 500;
	border-right: 1px solid var(--rule);
	min-width: 48px;
	justify-content: center;
}

.cu-input--phone {
	border: none !important;
	flex: 1;
	min-width: 0;
}

.cu-input--phone:focus { border: none !important; }

.cu-input--dial {
	border: none !important;
	border-right: 1px solid var(--rule) !important;
	background: var(--bg-subtle);
	border-radius: 0;
	max-width: 200px;
	flex: 0 0 200px;
}

.cu-verify-slot {
	display: flex;
	align-items: center;
	min-height: 42px;
	/* Vertical offset equal to the adjacent cu-label height (10px text + ~2px
	   leading + 8px bottom margin) so the action lines up horizontally with
	   the input field, not with the hint text below it. */
	margin-top: 20px;
}

.cu-verified-inline {
	display: flex;
	align-items: center;
	gap: 8px;
	font-family: var(--sans);
	font-size: 14px;
	font-weight: 500;
	color: var(--accent);
}

.cu-verified-check {
	width: 18px;
	height: 18px;
	color: var(--accent);
	flex-shrink: 0;
}

.cu-code-inline {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.cu-input--code-inline {
	font-family: var(--mono);
	font-size: 16px;
	letter-spacing: 0.18em;
	text-align: center;
	width: 140px;
	padding: 8px 10px;
}

/* ---------------- CALLOUT ---------------- */

.cu-callout {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 12px 16px;
	border-radius: 2px;
	margin: 16px 0 0;
	font-size: 13.5px;
}

.cu-callout--warn {
	background: var(--warn-soft);
	color: var(--warn);
	border-left: 3px solid var(--warn);
}

/* ---------------- FIELDS ---------------- */

.cu-field { margin-bottom: 22px; }

.cu-field-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;
	margin-bottom: 6px;
}

.cu-label {
	display: block;
	font-family: var(--mono);
	font-size: 10px;
	font-weight: 500;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--ink-quiet);
	margin-bottom: 8px;
}

.cu-input {
	font-family: var(--sans);
	font-size: 15px;
	font-weight: 400;
	color: var(--ink);
	background: var(--bg);
	border: 1px solid var(--rule);
	border-radius: 2px;
	padding: 10px 12px;
	width: 100%;
	outline: none;
	letter-spacing: -0.003em;
	transition: border-color 140ms ease;
}

.cu-input::placeholder { color: var(--ink-quiet); }
.cu-input:hover  { border-color: var(--ink-muted); }
.cu-input:focus  { border-color: var(--ink); }
.cu-input:disabled { background: var(--bg-locked); color: var(--ink-muted); }

.cu-input.has-error   { border-color: var(--err); }
.cu-input.has-success { border-color: var(--ok); }

.cu-input-cluster { position: relative; }
.cu-input-cluster .cu-input { padding-right: 56px; }

.cu-input-toggle {
	position: absolute;
	right: 4px;
	top: 50%;
	transform: translateY(-50%);
	font-family: var(--mono);
	font-size: 11px;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: var(--ink-muted);
	background: transparent;
	border: none;
	padding: 6px 10px;
	cursor: pointer;
	transition: color 140ms ease;
	border-radius: 2px;
}

.cu-input-toggle:hover { color: var(--ink); background: var(--bg-subtle); }

.cu-field-foot {
	margin-top: 6px;
	min-height: 16px;
	font-family: var(--sans);
	font-size: 12.5px;
	line-height: 1.4;
}

.cu-field-hint    { color: var(--ink-quiet); }
.cu-field-error   { color: var(--err); }
.cu-field-success { color: var(--ok); }

.cu-fieldset { border: none; padding: 0; margin: 0; }

/* ---------------- PASSWORD STRENGTH + CHECKLIST ---------------- */

.cu-pw-panel {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 28px;
	padding: 16px 0 0;
	margin-top: 4px;
	border-top: 1px solid var(--rule-soft);
}

.cu-pw-meter { display: flex; flex-direction: column; gap: 8px; }

.cu-pw-label {
	font-family: var(--mono);
	font-size: 10px;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--ink-quiet);
}

.cu-pw-track {
	height: 3px;
	background: var(--rule);
	border-radius: 2px;
	overflow: hidden;
}

.cu-pw-fill {
	height: 100%;
	background: var(--ink-quiet);
	border-radius: 2px;
	transition: width 300ms ease, background 200ms ease;
}

.cu-pw-fill.is-poor   { background: var(--err); }
.cu-pw-fill.is-weak   { background: var(--warn); }
.cu-pw-fill.is-ok     { background: var(--accent); }
.cu-pw-fill.is-strong { background: var(--accent-deep); }

.cu-pw-value {
	font-family: var(--mono);
	font-size: 11px;
	letter-spacing: 0.05em;
	color: var(--ink-muted);
}

.cu-pw-checklist {
	list-style: none;
	margin: 0;
	padding: 0;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 4px 14px;
}

.cu-pw-checklist li {
	display: flex;
	align-items: center;
	gap: 8px;
	font-family: var(--sans);
	font-size: 12.5px;
	color: var(--ink-quiet);
	transition: color 180ms ease;
}

.cu-pw-checklist li.is-met { color: var(--ink); }

.cu-pw-dot {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: var(--rule);
	transition: background 180ms ease;
}

.cu-pw-checklist li.is-met .cu-pw-dot { background: var(--accent); }

/* ---------------- ALERTS ---------------- */

.cu-alerts {
	margin: 36px 0 0;
	padding-left: 80px;
}

.cu-alerts ::ng-deep .alert {
	font-family: var(--sans);
	font-size: 14px;
	border-radius: 2px;
	border: 1px solid var(--rule);
	border-left: 3px solid var(--err);
	background: #FDF2F2;
	color: var(--err);
}

.cu-alerts ::ng-deep .alert .btn-close {
	font-size: 11px;
	opacity: 0.6;
}

/* ---------------- COMMIT FOOTER ---------------- */

.cu-commit {
	margin-top: 48px;
	padding: 28px 0 0 80px;
	border-top: 1px solid var(--rule);
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 32px;
}

.cu-commit-meta {
	flex: 1;
	font-family: var(--sans);
	font-size: 12.5px;
	color: var(--ink-muted);
	line-height: 1.55;
	max-width: 34em;
}

.cu-commit-meta a {
	color: var(--ink-muted);
	text-decoration: underline;
	text-decoration-color: var(--rule);
	text-underline-offset: 3px;
	transition: text-decoration-color 140ms ease, color 140ms ease;
}

.cu-commit-meta a:hover {
	color: var(--ink);
	text-decoration-color: var(--ink);
}

.cu-commit-agreements {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-width: 34em;
}

.cu-agreement-check {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-family: var(--sans);
	font-size: 12.5px;
	color: var(--ink-muted);
	line-height: 1.55;
	cursor: pointer;
	margin: 0;
}

.cu-agreement-check input[type="checkbox"] {
	flex-shrink: 0;
	width: 16px;
	height: 16px;
	margin-top: 2px;
	accent-color: var(--accent);
	cursor: pointer;
}

.cu-agreement-check a {
	color: var(--ink-muted);
	text-decoration: underline;
	text-decoration-color: var(--rule);
	text-underline-offset: 3px;
	transition: text-decoration-color 140ms ease, color 140ms ease;
}

.cu-agreement-check a:hover {
	color: var(--ink);
	text-decoration-color: var(--ink);
}

/* ---------------- RESPONSIVE ---------------- */

@media (max-width: 720px) {
	.cu-page { padding: 24px 18px 56px; }

	.cu-title-block { padding-left: 0; margin-bottom: 32px; }
	.cu-headline { font-size: 26px; }
	.cu-deck { font-size: 14.5px; }

	.cu-rail {
		padding-left: 0;
		margin-bottom: 36px;
		overflow-x: auto;
		justify-content: flex-start;
		gap: 4px;
	}
	.cu-rail-step { min-width: 96px; }
	.cu-rail-label { font-size: 9px; letter-spacing: 0.06em; }
	.cu-rail-link { min-width: 12px; max-width: 32px; margin-bottom: 22px; }

	.cu-section {
		grid-template-columns: 1fr;
		padding: 32px 0 4px;
	}

	.cu-section-rail {
		flex-direction: row;
		align-items: center;
		gap: 12px;
		padding-top: 0;
		margin-bottom: 12px;
	}

	.cu-section-rule { margin-top: 0; }
	.cu-section-title { font-size: 17px; }

	.cu-field-grid,
	.cu-pw-panel,
	.cu-phone-row {
		grid-template-columns: 1fr;
		gap: 18px;
	}

	.cu-channel-toggle { grid-template-columns: 1fr; }
	.cu-channel { border-right: none; border-bottom: 1px solid var(--rule); }
	.cu-channel:last-child { border-bottom: none; }

	.cu-input--dial { max-width: 100%; flex: 0 0 auto; border-right: none !important; border-bottom: 1px solid var(--rule) !important; }
	.cu-phone-cluster { flex-direction: column; }
	.cu-phone-prefix { border-right: none; border-bottom: 1px solid var(--rule); min-width: 100%; justify-content: flex-start; padding: 6px 12px; }

	.cu-verify-slot { margin-top: 0; }

	.cu-alerts { padding-left: 0; }

	.cu-commit {
		flex-direction: column;
		align-items: stretch;
		padding-left: 0;
		gap: 16px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/create-user/create-user.component.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;CACC,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;;CAE1B,+GAA+G;CAC/G,yEAAyE;AAC1E;;AAEA,2CAA2C;;AAE3C;CACC,iBAAiB;CACjB,qBAAqB;CACrB,uBAAuB;CACvB,wBAAwB;CACxB,iBAAiB;CACjB,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,cAAc;AACf;;AAEA,+CAA+C;;AAE/C;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,oBAAoB;CACpB,oCAAoC;CACpC,mBAAmB;AACpB;;AAEA,YAAY,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE3D;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,gBAAgB;CAChB,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,sBAAsB;CACtB,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA,kDAAkD;;AAElD;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,sBAAsB;CACtB,yBAAyB;CACzB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,iCAAiC;CACjC,gBAAgB;CAChB,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,eAAe;CACf,SAAS;AACV;;AAEA,+DAA+D;;AAE/D;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;CACnB,MAAM;AACP;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,+BAA+B;CAC/B,qBAAqB;CACrB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,uBAAuB;CACvB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,qBAAqB;CACrB,4CAA4C;AAC7C;;AAEA;CACC,2BAA2B;CAC3B,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,uBAAuB;CACvB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,cAAc;CACd,cAAc;CACd,sBAAsB;CACtB,uBAAuB;CACvB,eAAe;AAChB;;AAEA,yCAAyC,iBAAiB,EAAE;AAC5D,yCAAyC,sBAAsB,EAAE;AACjE,yCAAyC,uBAAuB,EAAE;;AAElE;CACC,OAAO;CACP,WAAW;CACX,uBAAuB;CACvB,cAAc;CACd,eAAe;CACf,eAAe;CACf,iCAAiC;CACjC,mBAAmB,EAAE,qCAAqC;AAC3D;;AAEA,wBAAwB,yBAAyB,EAAE;;AAEnD,oDAAoD;;AAEpD;CACC,aAAa;CACb,+BAA+B;CAC/B,MAAM;CACN,mBAAmB;CACnB,sCAAsC;CACtC,8BAA8B;AAC/B;;AAEA,4BAA4B,iCAAiC,EAAE;;AAE/D;CACC,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,iCAAiC;AAClC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,cAAc;CACd,4BAA4B;AAC7B;;AAEA,0CAA0C,oBAAoB,EAAE;AAChE,wCAAwC,iBAAiB,EAAE;;AAE3D;CACC,cAAc;CACd,WAAW;CACX,WAAW;CACX,uBAAuB;CACvB,gBAAgB;CAChB,mDAAmD;AACpD;;AAEA,2CAA2C,yBAAyB,EAAE,WAAW,EAAE;AACnF,2CAA2C,sBAAsB,EAAE,WAAW,EAAE;;AAEhF,mBAAmB,YAAY,EAAE;;AAEjC;CACC,aAAa;CACb,qBAAqB;CACrB,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,wBAAwB;CACxB,iBAAiB;CACjB,SAAS;CACT,OAAO;AACR;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,qBAAqB;CACrB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;;CAGC,uBAAuB;CACvB,6BAA6B;CAC7B,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;CACvB,8BAA8B;AAC/B;;AAEA;;CAEC,gBAAgB;CAChB,yBAAyB;CACzB,+BAA+B;AAChC;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,eAAe;AAChB;;AAEA,sDAAsD;AACtD,yEAAyE;;AAEzE;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CACnB,yCAAyC;AAC1C;;AAEA,mCAAmC,eAAe,EAAE;;AAEpD;CACC,cAAc;CACd,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,qDAAqD;AACtD;;AAEA,8CAA8C;;AAE9C;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,6BAA6B;CAC7B,uBAAuB;CACvB,eAAe;CACf,4EAA4E;CAC5E,cAAc;AACf;;AAEA,mBAAmB,YAAY,EAAE,mBAAmB,EAAE;;AAEtD;CACC,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,wBAAwB;CACxB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,oBAAoB;CACpB,uBAAuB;CACvB,YAAY;CACZ,cAAc;CACd,eAAe;CACf,qBAAqB;CACrB,oCAAoC;CACpC,mCAAmC;AACpC;;AAEA,iBAAiB,kCAAkC,EAAE;AACrD,kBAAkB,uBAAuB,EAAE;AAC3C,wBAAwB,iBAAiB,EAAE,+BAA+B,EAAE;;AAE5E,kEAAkE;;AAElE;CACC,aAAa;CACb,8BAA8B;CAC9B,MAAM;CACN,gBAAgB;CAChB,6BAA6B;CAC7B,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB,uBAAuB;CACvB,YAAY;CACZ,mCAAmC;CACnC,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,oBAAoB;AACrB;;AAEA,yBAAyB,kBAAkB,EAAE;AAC7C,oCAAoC,4BAA4B,EAAE;;AAElE;CACC,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA,0CAA0C,gBAAgB,EAAE,aAAa,EAAE;;AAE3E;CACC,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA,0CAA0C,gBAAgB,EAAE;;AAE5D,wDAAwD;AACxD,wFAAwF;;AAExF;CACC,aAAa;CACb,wDAAwD;CACxD,SAAS;CACT,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,6BAA6B;CAC7B,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,mCAAmC;AACpC;;AAEA,iCAAiC,wBAAwB,EAAE;;AAE3D;CACC,oBAAoB;CACpB,mBAAmB;CACnB,eAAe;CACf,4BAA4B;CAC5B,uBAAuB;CACvB,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,mCAAmC;CACnC,eAAe;CACf,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;CACvB,OAAO;CACP,YAAY;AACb;;AAEA,yBAAyB,uBAAuB,EAAE;;AAElD;CACC,uBAAuB;CACvB,8CAA8C;CAC9C,4BAA4B;CAC5B,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB;;uDAEsD;CACtD,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;AAClB;;AAEA,8CAA8C;;AAE9C;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,kCAAkC;AACnC;;AAEA,6CAA6C;;AAE7C,YAAY,mBAAmB,EAAE;;AAEjC;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,6BAA6B;CAC7B,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,wBAAwB;CACxB,mCAAmC;AACpC;;AAEA,yBAAyB,uBAAuB,EAAE;AAClD,mBAAmB,8BAA8B,EAAE;AACnD,mBAAmB,wBAAwB,EAAE;AAC7C,qBAAqB,4BAA4B,EAAE,uBAAuB,EAAE;;AAE5E,wBAAwB,wBAAwB,EAAE;AAClD,wBAAwB,uBAAuB,EAAE;;AAEjD,oBAAoB,kBAAkB,EAAE;AACxC,8BAA8B,mBAAmB,EAAE;;AAEnD;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,2BAA2B;CAC3B,wBAAwB;CACxB,eAAe;CACf,sBAAsB;CACtB,yBAAyB;CACzB,uBAAuB;CACvB,uBAAuB;CACvB,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA,yBAAyB,iBAAiB,EAAE,4BAA4B,EAAE;;AAE1E;CACC,eAAe;CACf,gBAAgB;CAChB,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA,oBAAoB,uBAAuB,EAAE;AAC7C,oBAAoB,iBAAiB,EAAE;AACvC,oBAAoB,gBAAgB,EAAE;;AAEtC,eAAe,YAAY,EAAE,UAAU,EAAE,SAAS,EAAE;;AAEpD,oEAAoE;;AAEpE;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,iBAAiB;CACjB,eAAe;CACf,sCAAsC;AACvC;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEhE;CACC,wBAAwB;CACxB,eAAe;CACf,qBAAqB;CACrB,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,4BAA4B;CAC5B,kBAAkB;CAClB,mDAAmD;AACpD;;AAEA,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,uBAAuB,EAAE;AACjD,wBAAwB,yBAAyB,EAAE;AACnD,wBAAwB,8BAA8B,EAAE;;AAExD;CACC,wBAAwB;CACxB,eAAe;CACf,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,aAAa;CACb,8BAA8B;CAC9B,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,wBAAwB;CACxB,iBAAiB;CACjB,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA,6BAA6B,iBAAiB,EAAE;;AAEhD;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,uBAAuB;CACvB,iCAAiC;AAClC;;AAEA,wCAAwC,yBAAyB,EAAE;;AAEnE,6CAA6C;;AAE7C;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,6BAA6B;CAC7B,iCAAiC;CACjC,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA,oDAAoD;;AAEpD;CACC,gBAAgB;CAChB,sBAAsB;CACtB,iCAAiC;CACjC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,OAAO;CACP,wBAAwB;CACxB,iBAAiB;CACjB,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,kCAAkC;CAClC,0BAA0B;CAC1B,8DAA8D;AAC/D;;AAEA;CACC,iBAAiB;CACjB,iCAAiC;AAClC;;AAEA;CACC,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,SAAS;CACT,wBAAwB;CACxB,iBAAiB;CACjB,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,SAAS;AACV;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,eAAe;CACf,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,kCAAkC;CAClC,0BAA0B;CAC1B,8DAA8D;AAC/D;;AAEA;CACC,iBAAiB;CACjB,iCAAiC;AAClC;;AAEA,iDAAiD;;AAEjD;CACC,WAAW,uBAAuB,EAAE;;CAEpC,kBAAkB,eAAe,EAAE,mBAAmB,EAAE;CACxD,eAAe,eAAe,EAAE;CAChC,WAAW,iBAAiB,EAAE;;CAE9B;EACC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,QAAQ;CACT;CACA,gBAAgB,eAAe,EAAE;CACjC,iBAAiB,cAAc,EAAE,sBAAsB,EAAE;CACzD,gBAAgB,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE;;CAEvE;EACC,0BAA0B;EAC1B,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;CACpB;;CAEA,mBAAmB,aAAa,EAAE;CAClC,oBAAoB,eAAe,EAAE;;CAErC;;;EAGC,0BAA0B;EAC1B,SAAS;CACV;;CAEA,qBAAqB,0BAA0B,EAAE;CACjD,cAAc,kBAAkB,EAAE,oCAAoC,EAAE;CACxE,yBAAyB,mBAAmB,EAAE;;CAE9C,kBAAkB,eAAe,EAAE,cAAc,EAAE,6BAA6B,EAAE,+CAA+C,EAAE;CACnI,oBAAoB,sBAAsB,EAAE;CAC5C,mBAAmB,kBAAkB,EAAE,oCAAoC,EAAE,eAAe,EAAE,2BAA2B,EAAE,iBAAiB,EAAE;;CAE9I,kBAAkB,aAAa,EAAE;;CAEjC,aAAa,eAAe,EAAE;;CAE9B;EACC,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,SAAS;CACV;AACD","sourcesContent":["/* ============================================================\n   CREATE USER — Professional Onboarding\n   Three-step flow with Stripe-style step rail.\n   Influences: Stripe (locked-step gating), Airtable (record\n   cards), IBM Carbon (calm density, functional restraint).\n   ============================================================ */\n\n:host {\n\t--bg:              #FFFFFF;\n\t--bg-subtle:       #F7F7F5;\n\t--bg-locked:       #FAFAF9;\n\t--ink:             #161616;\n\t--ink-soft:        #393939;\n\t--ink-muted:       #525252;\n\t--ink-quiet:       #8D8D8D;\n\t--ink-faint:       #BDBDBD;\n\t--rule:            #E0E0E0;\n\t--rule-soft:       #EDEDED;\n\t--accent:          #2D6C35;\n\t--accent-deep:     #1F4E25;\n\t--accent-soft:     #EEF3EE;\n\t--warn:            #8A5A1F;\n\t--warn-soft:       #FBF3E4;\n\t--err:             #DA1E28;\n\t--ok:              #2D6C35;\n\n\t--sans:            'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n\t--mono:            'IBM Plex Mono', 'SF Mono', Menlo, Consolas, monospace;\n}\n\n/* ---------------- PAGE ---------------- */\n\n.cu-page {\n\tmin-height: 100vh;\n\tbackground: var(--bg);\n\tpadding: 56px 24px 96px;\n\tfont-family: var(--sans);\n\tcolor: var(--ink);\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\n.cu-paper {\n\tmax-width: 820px;\n\tmargin: 0 auto;\n\tdisplay: block;\n}\n\n/* ---------------- MASTHEAD ---------------- */\n\n.cu-masthead {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding-bottom: 20px;\n\tborder-bottom: 1px solid var(--rule);\n\tmargin-bottom: 56px;\n}\n\n.cu-brand { display: flex; align-items: center; gap: 12px; }\n\n.cu-brand-mark {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 32px;\n\theight: 32px;\n\tbackground: var(--ink);\n\tcolor: var(--bg);\n\tfont-family: var(--mono);\n\tfont-weight: 500;\n\tfont-size: 11px;\n\tletter-spacing: 0.06em;\n\tborder-radius: 2px;\n}\n\n.cu-brand-name {\n\tfont-family: var(--sans);\n\tfont-weight: 500;\n\tfont-size: 13px;\n\tletter-spacing: 0.01em;\n\tcolor: var(--ink);\n}\n\n.cu-masthead-meta {\n\tfont-family: var(--mono);\n\tfont-size: 11px;\n\tletter-spacing: 0.08em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-quiet);\n}\n\n/* ---------------- TITLE BLOCK ---------------- */\n\n.cu-title-block {\n\tmargin: 0 0 40px;\n\tpadding-left: 80px;\n}\n\n.cu-kicker {\n\tfont-family: var(--mono);\n\tfont-size: 11px;\n\tletter-spacing: 0.14em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-muted);\n\tmargin: 0 0 16px;\n}\n\n.cu-headline {\n\tfont-family: var(--sans);\n\tfont-weight: 500;\n\tfont-size: clamp(28px, 4vw, 36px);\n\tline-height: 1.2;\n\tletter-spacing: -0.018em;\n\tcolor: var(--ink);\n\tmargin: 0 0 14px;\n}\n\n.cu-deck {\n\tfont-family: var(--sans);\n\tfont-weight: 400;\n\tfont-size: 15px;\n\tline-height: 1.6;\n\tcolor: var(--ink-muted);\n\tmax-width: 38em;\n\tmargin: 0;\n}\n\n/* ---------------- STEP RAIL (Stripe-style) ---------------- */\n\n.cu-rail {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 0 0 48px;\n\tpadding: 0 0 0 80px;\n\tgap: 0;\n}\n\n.cu-rail-step {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 8px;\n\tflex-shrink: 0;\n\tmin-width: 120px;\n}\n\n.cu-rail-node {\n\twidth: 32px;\n\theight: 32px;\n\tborder-radius: 50%;\n\tborder: 1.5px solid var(--rule);\n\tbackground: var(--bg);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-family: var(--mono);\n\tfont-weight: 500;\n\tfont-size: 12px;\n\tcolor: var(--ink-quiet);\n\ttransition: all 200ms ease;\n\tline-height: 1;\n}\n\n.cu-rail-step.is-active .cu-rail-node {\n\tborder-color: var(--ink);\n\tcolor: var(--ink);\n\tbackground: var(--bg);\n\tbox-shadow: 0 0 0 4px rgba(22, 22, 22, 0.06);\n}\n\n.cu-rail-step.is-done .cu-rail-node {\n\tborder-color: var(--accent);\n\tbackground: var(--accent);\n\tcolor: var(--bg);\n}\n\n.cu-rail-step.is-locked .cu-rail-node {\n\tbackground: var(--bg-locked);\n\tborder-color: var(--rule-soft);\n\tcolor: var(--ink-faint);\n}\n\n.cu-rail-label {\n\tfont-family: var(--mono);\n\tfont-size: 10px;\n\tfont-weight: 500;\n\tletter-spacing: 0.08em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-quiet);\n\ttext-align: center;\n\twhite-space: nowrap;\n\tline-height: 1.3;\n\ttransition: color 200ms ease;\n}\n\n.cu-rail-optional {\n\tdisplay: block;\n\tfont-size: 9px;\n\tletter-spacing: 0.06em;\n\tcolor: var(--ink-faint);\n\tmargin-top: 2px;\n}\n\n.cu-rail-step.is-active .cu-rail-label { color: var(--ink); }\n.cu-rail-step.is-done .cu-rail-label   { color: var(--ink-soft); }\n.cu-rail-step.is-locked .cu-rail-label { color: var(--ink-faint); }\n\n.cu-rail-link {\n\tflex: 1;\n\theight: 1px;\n\tbackground: var(--rule);\n\tmargin: 0 -8px;\n\tmin-width: 24px;\n\tmax-width: 80px;\n\ttransition: background 240ms ease;\n\tmargin-bottom: 24px; /* vertical-align with node centers */\n}\n\n.cu-rail-link.is-done { background: var(--accent); }\n\n/* ---------------- SECTION FRAME ---------------- */\n\n.cu-section {\n\tdisplay: grid;\n\tgrid-template-columns: 80px 1fr;\n\tgap: 0;\n\tpadding: 44px 0 8px;\n\tborder-top: 1px solid var(--rule-soft);\n\ttransition: opacity 240ms ease;\n}\n\n.cu-section:first-of-type { border-top: 1px solid var(--rule); }\n\n.cu-section.is-locked {\n\topacity: 0.5;\n\tpointer-events: none;\n}\n\n.cu-section--usef {\n\tpadding-top: 48px;\n\tmargin-top: 12px;\n\tborder-top: 1px solid var(--rule);\n}\n\n.cu-section-rail {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tpadding-top: 2px;\n}\n\n.cu-section-num {\n\tfont-family: var(--mono);\n\tfont-weight: 500;\n\tfont-size: 12px;\n\tletter-spacing: 0.05em;\n\tcolor: var(--ink-quiet);\n\tline-height: 1;\n\ttransition: color 200ms ease;\n}\n\n.cu-section.is-complete .cu-section-num { color: var(--accent); }\n.cu-section.is-active .cu-section-num { color: var(--ink); }\n\n.cu-section-rule {\n\tdisplay: block;\n\twidth: 24px;\n\theight: 1px;\n\tbackground: var(--rule);\n\tmargin-top: 12px;\n\ttransition: background 200ms ease, width 200ms ease;\n}\n\n.cu-section.is-complete .cu-section-rule { background: var(--accent); width: 36px; }\n.cu-section.is-active .cu-section-rule   { background: var(--ink); width: 36px; }\n\n.cu-section-body { min-width: 0; }\n\n.cu-section-head {\n\tdisplay: flex;\n\talign-items: baseline;\n\tgap: 12px;\n\tmargin-bottom: 10px;\n}\n\n.cu-section-title {\n\tfont-family: var(--sans);\n\tfont-weight: 500;\n\tfont-size: 19px;\n\tline-height: 1.25;\n\tletter-spacing: -0.005em;\n\tcolor: var(--ink);\n\tmargin: 0;\n\tflex: 1;\n}\n\n.cu-section-status {\n\tfont-family: var(--mono);\n\tfont-size: 10px;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tpadding: 3px 8px;\n\tborder-radius: 2px;\n\twhite-space: nowrap;\n}\n\n.cu-section-status--optional,\n.cu-section-status--required,\n.cu-section-status--locked {\n\tcolor: var(--ink-muted);\n\tborder: 1px solid var(--rule);\n\tbackground: transparent;\n}\n\n.cu-section-status--locked {\n\tcolor: var(--ink-faint);\n\tborder-color: var(--rule-soft);\n}\n\n.cu-section-status--done,\n.cu-section-status--unlocked {\n\tcolor: var(--bg);\n\tbackground: var(--accent);\n\tborder: 1px solid var(--accent);\n}\n\n.cu-prose {\n\tfont-family: var(--sans);\n\tfont-weight: 400;\n\tfont-size: 14px;\n\tline-height: 1.6;\n\tcolor: var(--ink-muted);\n\tmargin: 0 0 20px;\n\tmax-width: 40em;\n}\n\n/* ---------------- SUB-GROUP LABEL ---------------- */\n/* Used inside a section to mark a logical group (Name / Phone / Email) */\n\n.cu-subgroup-label {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tfont-family: var(--mono);\n\tfont-size: 10px;\n\tfont-weight: 500;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-quiet);\n\tmargin: 24px 0 12px;\n\tpadding-bottom: 6px;\n\tborder-bottom: 1px solid var(--rule-soft);\n}\n\n.cu-subgroup-label:first-of-type { margin-top: 4px; }\n\n.cu-subgroup-flag {\n\tfont-size: 9px;\n\tletter-spacing: 0.08em;\n\tcolor: var(--warn);\n\tpadding: 2px 6px;\n\tbackground: var(--warn-soft);\n\tborder-radius: 2px;\n}\n\n.cu-subgroup-flag--quiet {\n\tcolor: var(--ink-quiet);\n\tbackground: var(--surface-quiet, rgba(0, 0, 0, 0.04));\n}\n\n/* ---------------- BUTTONS ---------------- */\n\n.cu-btn {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 8px;\n\tfont-family: var(--sans);\n\tfont-weight: 500;\n\tfont-size: 14px;\n\tpadding: 11px 18px;\n\tborder-radius: 2px;\n\tborder: 1px solid transparent;\n\tbackground: transparent;\n\tcursor: pointer;\n\ttransition: background 140ms ease, color 140ms ease, border-color 140ms ease;\n\tline-height: 1;\n}\n\n.cu-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.cu-btn--ghost {\n\tcolor: var(--ink);\n\tborder-color: var(--ink);\n}\n\n.cu-btn--ghost:hover:not(:disabled) {\n\tcolor: var(--bg);\n\tbackground: var(--ink);\n}\n\n.cu-btn--primary {\n\tcolor: var(--bg);\n\tbackground: var(--accent);\n\tborder-color: var(--accent);\n}\n\n.cu-btn--primary:hover:not(:disabled) {\n\tbackground: var(--accent-deep);\n\tborder-color: var(--accent-deep);\n}\n\n.cu-btn--commit {\n\tcolor: var(--bg);\n\tbackground: var(--ink);\n\tborder-color: var(--ink);\n\tpadding: 13px 24px;\n\tfont-size: 14px;\n}\n\n.cu-btn--commit:hover:not(:disabled) {\n\tbackground: var(--accent-deep);\n\tborder-color: var(--accent-deep);\n}\n\n.cu-action-row {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 18px;\n\tmargin-top: 4px;\n}\n\n.cu-link {\n\tfont-family: var(--sans);\n\tfont-weight: 500;\n\tfont-size: 13px;\n\tcolor: var(--accent);\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 6px 0;\n\tcursor: pointer;\n\ttext-decoration: none;\n\tborder-bottom: 1px solid transparent;\n\ttransition: border-color 140ms ease;\n}\n\n.cu-link:hover { border-bottom-color: var(--accent); }\n.cu-link--muted { color: var(--ink-muted); }\n.cu-link--muted:hover { color: var(--ink); border-bottom-color: var(--ink); }\n\n/* ---------------- CHANNEL TOGGLE (Phone type) ---------------- */\n\n.cu-channel-toggle {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 0;\n\tmargin: 0 0 18px;\n\tborder: 1px solid var(--rule);\n\tborder-radius: 2px;\n\toverflow: hidden;\n\tbackground: var(--bg);\n\tmax-width: 480px;\n}\n\n.cu-channel {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tpadding: 12px 16px;\n\tbackground: transparent;\n\tborder: none;\n\tborder-right: 1px solid var(--rule);\n\tcursor: pointer;\n\ttext-align: left;\n\ttransition: background 140ms ease;\n\tfont-family: inherit;\n}\n\n.cu-channel:last-child { border-right: none; }\n.cu-channel:hover:not(.is-active) { background: var(--bg-subtle); }\n\n.cu-channel.is-active {\n\tbackground: var(--ink);\n\tcolor: var(--bg);\n}\n\n.cu-channel-label {\n\tfont-family: var(--mono);\n\tfont-size: 10px;\n\tfont-weight: 500;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-quiet);\n\tmargin-bottom: 4px;\n}\n\n.cu-channel.is-active .cu-channel-label { color: var(--bg); opacity: 0.65; }\n\n.cu-channel-value {\n\tfont-family: var(--sans);\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: var(--ink);\n\tletter-spacing: -0.003em;\n}\n\n.cu-channel.is-active .cu-channel-value { color: var(--bg); }\n\n/* ---------------- PHONE / EMAIL ROW ---------------- */\n/* A row that pairs an input field on the left with a verify-action slot on the right. */\n\n.cu-phone-row {\n\tdisplay: grid;\n\tgrid-template-columns: minmax(0, 1fr) minmax(280px, 1fr);\n\tgap: 24px;\n\talign-items: start;\n\tmargin-bottom: 4px;\n}\n\n.cu-phone-cluster {\n\tdisplay: flex;\n\talign-items: stretch;\n\tborder: 1px solid var(--rule);\n\tborder-radius: 2px;\n\toverflow: hidden;\n\tbackground: var(--bg);\n\ttransition: border-color 140ms ease;\n}\n\n.cu-phone-cluster:focus-within { border-color: var(--ink); }\n\n.cu-phone-prefix {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tpadding: 0 12px;\n\tbackground: var(--bg-subtle);\n\tcolor: var(--ink-muted);\n\tfont-family: var(--mono);\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tborder-right: 1px solid var(--rule);\n\tmin-width: 48px;\n\tjustify-content: center;\n}\n\n.cu-input--phone {\n\tborder: none !important;\n\tflex: 1;\n\tmin-width: 0;\n}\n\n.cu-input--phone:focus { border: none !important; }\n\n.cu-input--dial {\n\tborder: none !important;\n\tborder-right: 1px solid var(--rule) !important;\n\tbackground: var(--bg-subtle);\n\tborder-radius: 0;\n\tmax-width: 200px;\n\tflex: 0 0 200px;\n}\n\n.cu-verify-slot {\n\tdisplay: flex;\n\talign-items: center;\n\tmin-height: 42px;\n\t/* Vertical offset equal to the adjacent cu-label height (10px text + ~2px\n\t   leading + 8px bottom margin) so the action lines up horizontally with\n\t   the input field, not with the hint text below it. */\n\tmargin-top: 20px;\n}\n\n.cu-verified-inline {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tfont-family: var(--sans);\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: var(--accent);\n}\n\n.cu-verified-check {\n\twidth: 18px;\n\theight: 18px;\n\tcolor: var(--accent);\n\tflex-shrink: 0;\n}\n\n.cu-code-inline {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tflex-wrap: wrap;\n}\n\n.cu-input--code-inline {\n\tfont-family: var(--mono);\n\tfont-size: 16px;\n\tletter-spacing: 0.18em;\n\ttext-align: center;\n\twidth: 140px;\n\tpadding: 8px 10px;\n}\n\n/* ---------------- CALLOUT ---------------- */\n\n.cu-callout {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 14px;\n\tpadding: 12px 16px;\n\tborder-radius: 2px;\n\tmargin: 16px 0 0;\n\tfont-size: 13.5px;\n}\n\n.cu-callout--warn {\n\tbackground: var(--warn-soft);\n\tcolor: var(--warn);\n\tborder-left: 3px solid var(--warn);\n}\n\n/* ---------------- FIELDS ---------------- */\n\n.cu-field { margin-bottom: 22px; }\n\n.cu-field-grid {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 24px;\n\tmargin-bottom: 6px;\n}\n\n.cu-label {\n\tdisplay: block;\n\tfont-family: var(--mono);\n\tfont-size: 10px;\n\tfont-weight: 500;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-quiet);\n\tmargin-bottom: 8px;\n}\n\n.cu-input {\n\tfont-family: var(--sans);\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tcolor: var(--ink);\n\tbackground: var(--bg);\n\tborder: 1px solid var(--rule);\n\tborder-radius: 2px;\n\tpadding: 10px 12px;\n\twidth: 100%;\n\toutline: none;\n\tletter-spacing: -0.003em;\n\ttransition: border-color 140ms ease;\n}\n\n.cu-input::placeholder { color: var(--ink-quiet); }\n.cu-input:hover  { border-color: var(--ink-muted); }\n.cu-input:focus  { border-color: var(--ink); }\n.cu-input:disabled { background: var(--bg-locked); color: var(--ink-muted); }\n\n.cu-input.has-error   { border-color: var(--err); }\n.cu-input.has-success { border-color: var(--ok); }\n\n.cu-input-cluster { position: relative; }\n.cu-input-cluster .cu-input { padding-right: 56px; }\n\n.cu-input-toggle {\n\tposition: absolute;\n\tright: 4px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tfont-family: var(--mono);\n\tfont-size: 11px;\n\tletter-spacing: 0.06em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-muted);\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 6px 10px;\n\tcursor: pointer;\n\ttransition: color 140ms ease;\n\tborder-radius: 2px;\n}\n\n.cu-input-toggle:hover { color: var(--ink); background: var(--bg-subtle); }\n\n.cu-field-foot {\n\tmargin-top: 6px;\n\tmin-height: 16px;\n\tfont-family: var(--sans);\n\tfont-size: 12.5px;\n\tline-height: 1.4;\n}\n\n.cu-field-hint    { color: var(--ink-quiet); }\n.cu-field-error   { color: var(--err); }\n.cu-field-success { color: var(--ok); }\n\n.cu-fieldset { border: none; padding: 0; margin: 0; }\n\n/* ---------------- PASSWORD STRENGTH + CHECKLIST ---------------- */\n\n.cu-pw-panel {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 28px;\n\tpadding: 16px 0 0;\n\tmargin-top: 4px;\n\tborder-top: 1px solid var(--rule-soft);\n}\n\n.cu-pw-meter { display: flex; flex-direction: column; gap: 8px; }\n\n.cu-pw-label {\n\tfont-family: var(--mono);\n\tfont-size: 10px;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: var(--ink-quiet);\n}\n\n.cu-pw-track {\n\theight: 3px;\n\tbackground: var(--rule);\n\tborder-radius: 2px;\n\toverflow: hidden;\n}\n\n.cu-pw-fill {\n\theight: 100%;\n\tbackground: var(--ink-quiet);\n\tborder-radius: 2px;\n\ttransition: width 300ms ease, background 200ms ease;\n}\n\n.cu-pw-fill.is-poor   { background: var(--err); }\n.cu-pw-fill.is-weak   { background: var(--warn); }\n.cu-pw-fill.is-ok     { background: var(--accent); }\n.cu-pw-fill.is-strong { background: var(--accent-deep); }\n\n.cu-pw-value {\n\tfont-family: var(--mono);\n\tfont-size: 11px;\n\tletter-spacing: 0.05em;\n\tcolor: var(--ink-muted);\n}\n\n.cu-pw-checklist {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 4px 14px;\n}\n\n.cu-pw-checklist li {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tfont-family: var(--sans);\n\tfont-size: 12.5px;\n\tcolor: var(--ink-quiet);\n\ttransition: color 180ms ease;\n}\n\n.cu-pw-checklist li.is-met { color: var(--ink); }\n\n.cu-pw-dot {\n\twidth: 6px;\n\theight: 6px;\n\tborder-radius: 50%;\n\tbackground: var(--rule);\n\ttransition: background 180ms ease;\n}\n\n.cu-pw-checklist li.is-met .cu-pw-dot { background: var(--accent); }\n\n/* ---------------- ALERTS ---------------- */\n\n.cu-alerts {\n\tmargin: 36px 0 0;\n\tpadding-left: 80px;\n}\n\n.cu-alerts ::ng-deep .alert {\n\tfont-family: var(--sans);\n\tfont-size: 14px;\n\tborder-radius: 2px;\n\tborder: 1px solid var(--rule);\n\tborder-left: 3px solid var(--err);\n\tbackground: #FDF2F2;\n\tcolor: var(--err);\n}\n\n.cu-alerts ::ng-deep .alert .btn-close {\n\tfont-size: 11px;\n\topacity: 0.6;\n}\n\n/* ---------------- COMMIT FOOTER ---------------- */\n\n.cu-commit {\n\tmargin-top: 48px;\n\tpadding: 28px 0 0 80px;\n\tborder-top: 1px solid var(--rule);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 32px;\n}\n\n.cu-commit-meta {\n\tflex: 1;\n\tfont-family: var(--sans);\n\tfont-size: 12.5px;\n\tcolor: var(--ink-muted);\n\tline-height: 1.55;\n\tmax-width: 34em;\n}\n\n.cu-commit-meta a {\n\tcolor: var(--ink-muted);\n\ttext-decoration: underline;\n\ttext-decoration-color: var(--rule);\n\ttext-underline-offset: 3px;\n\ttransition: text-decoration-color 140ms ease, color 140ms ease;\n}\n\n.cu-commit-meta a:hover {\n\tcolor: var(--ink);\n\ttext-decoration-color: var(--ink);\n}\n\n.cu-commit-agreements {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\tmax-width: 34em;\n}\n\n.cu-agreement-check {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 10px;\n\tfont-family: var(--sans);\n\tfont-size: 12.5px;\n\tcolor: var(--ink-muted);\n\tline-height: 1.55;\n\tcursor: pointer;\n\tmargin: 0;\n}\n\n.cu-agreement-check input[type=\"checkbox\"] {\n\tflex-shrink: 0;\n\twidth: 16px;\n\theight: 16px;\n\tmargin-top: 2px;\n\taccent-color: var(--accent);\n\tcursor: pointer;\n}\n\n.cu-agreement-check a {\n\tcolor: var(--ink-muted);\n\ttext-decoration: underline;\n\ttext-decoration-color: var(--rule);\n\ttext-underline-offset: 3px;\n\ttransition: text-decoration-color 140ms ease, color 140ms ease;\n}\n\n.cu-agreement-check a:hover {\n\tcolor: var(--ink);\n\ttext-decoration-color: var(--ink);\n}\n\n/* ---------------- RESPONSIVE ---------------- */\n\n@media (max-width: 720px) {\n\t.cu-page { padding: 24px 18px 56px; }\n\n\t.cu-title-block { padding-left: 0; margin-bottom: 32px; }\n\t.cu-headline { font-size: 26px; }\n\t.cu-deck { font-size: 14.5px; }\n\n\t.cu-rail {\n\t\tpadding-left: 0;\n\t\tmargin-bottom: 36px;\n\t\toverflow-x: auto;\n\t\tjustify-content: flex-start;\n\t\tgap: 4px;\n\t}\n\t.cu-rail-step { min-width: 96px; }\n\t.cu-rail-label { font-size: 9px; letter-spacing: 0.06em; }\n\t.cu-rail-link { min-width: 12px; max-width: 32px; margin-bottom: 22px; }\n\n\t.cu-section {\n\t\tgrid-template-columns: 1fr;\n\t\tpadding: 32px 0 4px;\n\t}\n\n\t.cu-section-rail {\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tgap: 12px;\n\t\tpadding-top: 0;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.cu-section-rule { margin-top: 0; }\n\t.cu-section-title { font-size: 17px; }\n\n\t.cu-field-grid,\n\t.cu-pw-panel,\n\t.cu-phone-row {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 18px;\n\t}\n\n\t.cu-channel-toggle { grid-template-columns: 1fr; }\n\t.cu-channel { border-right: none; border-bottom: 1px solid var(--rule); }\n\t.cu-channel:last-child { border-bottom: none; }\n\n\t.cu-input--dial { max-width: 100%; flex: 0 0 auto; border-right: none !important; border-bottom: 1px solid var(--rule) !important; }\n\t.cu-phone-cluster { flex-direction: column; }\n\t.cu-phone-prefix { border-right: none; border-bottom: 1px solid var(--rule); min-width: 100%; justify-content: flex-start; padding: 6px 12px; }\n\n\t.cu-verify-slot { margin-top: 0; }\n\n\t.cu-alerts { padding-left: 0; }\n\n\t.cu-commit {\n\t\tflex-direction: column;\n\t\talign-items: stretch;\n\t\tpadding-left: 0;\n\t\tgap: 16px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
